(() => {
  'use strict';
  const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  let catalogueRequest;
  function loadCatalogue() {
    if (!catalogueRequest) catalogueRequest = fetch(document.body.dataset.rwCatalog).then(response => {
      if (!response.ok) throw Error('Catalogue unavailable');
      return response.json();
    }).catch(error => { catalogueRequest = null; throw error; });
    return catalogueRequest;
  }
  function initializeHero(scope) {
    const hero = scope.querySelector('.rw-play-visual');
    if (!hero || hero.dataset.lookReady) return;
    hero.dataset.lookReady = 'true';
    const photo = hero.querySelector('.rw-campaign-hero');
    const original = Object.fromEntries(['src', 'srcset', 'sizes', 'alt'].map(name => [name, photo.getAttribute(name)]));
    hero.querySelectorAll('[data-hero-look]').forEach(button => button.addEventListener('click', () => {
      hero.querySelectorAll('[data-hero-look]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      if (button.dataset.heroLook === 'everyday') {
        for (const [name, value] of Object.entries(original)) value === null ? photo.removeAttribute(name) : photo.setAttribute(name, value);
      } else {
        photo.removeAttribute('srcset');
        photo.src = button.dataset.image;
        photo.alt = button.dataset.alt;
      }
      hero.dataset.look = button.dataset.heroLook;
    }));
  }
  async function initialize(scope = document) {
    initializeHero(scope);
    const studio = scope.querySelector('[data-shape-playground]');
    if (!studio || studio.dataset.ready) return;
    studio.dataset.ready = 'true';
    const $ = selector => studio.querySelector(selector);
    const canvas = $('[data-demo-canvas]');
    const grid = $('[data-demo-options]');
    const width = $('#rw-demo-size');
    const height = $('#rw-demo-height');
    const useDesign = $('[data-demo-use]');
    const words = JSON.parse($('[data-demo-words]').textContent);
    try {
      const catalogue = await loadCatalogue();
      const shapes = catalogue.shapes.filter(shape => shape.outline?.lenses?.length === 2);
      if (!shapes.length) throw Error('No shapes available');
      let selected = shapes.find(shape => shape.number === '100') || shapes[0];
      let category = 'All', query = '', limit = 12;
      const categories = ['All', ...new Set(shapes.map(shape => shape.category))];
      const imageCache = new Set();
      function preload(shape) {
        if (imageCache.has(shape.number)) return;
        imageCache.add(shape.number);
        const image = new Image();
        image.src = shape.image;
      }
      const validRow = row => !!row && Number.isFinite(row.width) && Number.isFinite(row.height) && row.width > 0 && row.height >= 10 && row.height <= 80;
      function selectedSize() { return selected.sizes.find(row => row.overall === Number(width.value)); }
      function updateCategories() {
        $('[data-demo-categories]').innerHTML = categories.map(value => `<button type="button" data-demo-category="${escape(value)}" aria-pressed="${category === value}">${escape(words[value] || value)}</button>`).join('');
      }
      function updateGrid() {
        const filtered = shapes.filter(shape => (category === 'All' || category === shape.category) && `${shape.number} ${words[shape.category] || shape.category}`.toLowerCase().includes(query));
        const shown = filtered.slice(0, limit);
        grid.innerHTML = shown.length ? shown.map(shape => `<button type="button" class="rw-shape-tile" data-demo-shape="${escape(shape.number)}" aria-pressed="${shape.number === selected.number}" aria-label="${escape(words.choose + ' ' + (words[shape.category] || shape.category) + ' ' + words.shape + ' ' + shape.number)}"><span class="rw-shape-tile-check" aria-hidden="true">✓</span><img src="${escape(shape.image)}" alt="" width="240" height="136" loading="lazy"><span><strong>#${escape(shape.number)}</strong><small>${escape(words[shape.category] || shape.category)}</small></span></button>`).join('') : `<p class="rw-studio-no-results">${escape(words.none)}</p>`;
        $('[data-demo-result-count]').textContent = `${words.showing} ${shown.length} ${words.of} ${filtered.length} ${words.shapes}`;
        $('[data-demo-more]').hidden = shown.length >= filtered.length;
      }
      function lensDrawing(shape, row, offset, opacity, filter) {
        const h = row.height + offset, gap = 18, left = (200 - row.width * 2 - gap) / 2, top = 50 - h / 2;
        return `<g opacity="${opacity}" filter="url(#${filter})">${shape.outline.lenses.map((bounds, index) => `<svg x="${left + index * (row.width + gap)}" y="${top}" width="${row.width}" height="${h}" viewBox="${bounds.join(' ')}" preserveAspectRatio="none" overflow="hidden"><image href="${escape(shape.image)}" width="${shape.outline.imageWidth}" height="${shape.outline.imageHeight}"/></svg>`).join('')}</g>`;
      }
      function render() {
        width.max=selected.limits?'150':'160';width.value=Math.min(Number(width.max),Number(width.value));
        const fitRow=selectedSize();height.min=selected.limits&&validRow(fitRow)?String(Math.max(-4,Math.ceil(selected.limits.minHeight-fitRow.height))):'-4';height.value=Math.max(Number(height.min),Number(height.value));
        const row = selectedSize(), offset = Number(height.value), overall = Number(width.value), valid = validRow(row);
        preload(selected);
        $('[data-demo-name]').textContent = `${words[selected.category] || selected.category} / #${selected.number}`;
        $('[data-demo-size]').value = `${overall} mm`;
        $('[data-demo-height]').value = `${offset > 0 ? '+' : ''}${offset} mm`;
        $('[data-metric-overall]').innerHTML = `${overall} <small>mm</small>`;
        $('[data-metric-width]').innerHTML = valid ? `${row.width} <small>mm</small>` : '—';
        $('[data-metric-height]').innerHTML = valid ? `${row.height + offset} <small>mm</small>` : '—';
        $('[data-demo-warning]').hidden = valid;
        $('[data-demo-warning]').textContent = valid ? '' : words.held;
        useDesign.disabled = !valid;
        for (const button of grid.querySelectorAll('[data-demo-shape]')) button.setAttribute('aria-pressed', String(button.dataset.demoShape === selected.number));
        for (const button of studio.querySelectorAll('[data-adjust]')) {
          const [axis, direction] = button.dataset.adjust.split('-');
          const input = axis === 'width' ? width : height;
          button.disabled = Number(input.value) === Number(direction === 'up' ? input.max : input.min);
        }
        if (!valid) { canvas.innerHTML = `<p class="rw-preview-hold">${escape(words.held)}</p>`; return; }
        const lensHeight = row.height + offset;
        const top = 50 - lensHeight / 2;
        const original = selected.sizes.find(size => size.overall === 138);
        const compare = $('[data-demo-compare]').checked && validRow(original);
        const compareDrawing = compare ? lensDrawing(selected, original, 0, .35, 'rw-demo-original') : '';
        const measure = $('[data-demo-measure]').checked;
        const start = (200 - overall) / 2, end = (200 + overall) / 2;
        const measureDrawing = measure ? `<g fill="#013088" stroke="#7192ce" stroke-width=".35"><path d="M${start} 99 H${end} M${start} 96 V102 M${end} 96 V102"/><path d="M187 ${top} V${top + lensHeight} M184 ${top} H190 M184 ${top + lensHeight} H190"/><text x="100" y="109" text-anchor="middle" font-size="4.3" stroke="none">${overall} mm</text><text x="193" y="50" text-anchor="middle" font-size="4.3" stroke="none" transform="rotate(-90 193 50)">${lensHeight} mm</text></g>` : '';
        const legend = compare ? `<div class="rw-compare-key"><span>${escape(words.baseline)} · 138 mm</span><span>${escape(words.current)}</span></div>` : '';
        canvas.innerHTML = `<svg viewBox="0 0 200 116" role="img" aria-label="${escape(words.preview + ' ' + selected.number + ', ' + row.width + ' × ' + lensHeight + ' mm')}" font-family="Arial, sans-serif"><defs><filter id="rw-demo-blue" x="-5%" y="-5%" width="110%" height="110%" color-interpolation-filters="sRGB"><feColorMatrix type="matrix" values="0 0 0 0 .004 0 0 0 0 .188 0 0 0 0 .533 -.2126 -.7152 -.0722 1 0"/><feMorphology operator="dilate" radius=".1"/></filter><filter id="rw-demo-original" x="-5%" y="-5%" width="110%" height="110%" color-interpolation-filters="sRGB"><feColorMatrix type="matrix" values="0 0 0 0 .3 0 0 0 0 .36 0 0 0 0 .45 -.2126 -.7152 -.0722 1 0"/></filter></defs>${compareDrawing}${lensDrawing(selected, row, offset, 1, 'rw-demo-blue')}<path d="M91 ${top+7} Q100 ${top+2} 109 ${top+7}" stroke="#6882ae" stroke-width=".7" stroke-dasharray="1.5 1.5" fill="none"/>${measureDrawing}</svg>${legend}`;
      }
      $('[data-demo-categories]').addEventListener('click', event => {
        const button = event.target.closest('[data-demo-category]');
        if (!button) return;
        category = button.dataset.demoCategory; limit = 12; updateCategories(); updateGrid();
      });
      $('[data-demo-search]').addEventListener('input', event => { query = event.target.value.trim().toLowerCase().replace(/^#/, ''); limit = 12; updateGrid(); });
      grid.addEventListener('click', event => {
        const button = event.target.closest('[data-demo-shape]');
        if (!button) return;
        selected = shapes.find(shape => shape.number === button.dataset.demoShape);
        render();
        if (matchMedia('(max-width: 760px)').matches) studio.querySelector('.rw-playground-top').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
      });
      $('[data-demo-more]').addEventListener('click', () => { limit += 12; updateGrid(); });
      width.addEventListener('input', render); height.addEventListener('input', render);
      $('[data-demo-measure]').addEventListener('change', render);
      $('[data-demo-compare]').addEventListener('change', render);
      studio.querySelectorAll('[data-adjust]').forEach(button => button.addEventListener('click', () => {
        const [axis, direction] = button.dataset.adjust.split('-');
        const input = axis === 'width' ? width : height;
        input.value = Math.max(Number(input.min), Math.min(Number(input.max), Number(input.value) + (direction === 'up' ? 1 : -1) * Number(input.step)));
        render();
      }));
      $('[data-demo-reset]').addEventListener('click', () => {
        selected = shapes.find(shape => shape.number === '100') || shapes[0]; width.value = '138'; height.value = '0';
        category = 'All'; query = ''; limit = 12; $('[data-demo-search]').value = '';
        $('[data-demo-measure]').checked = true; $('[data-demo-compare]').checked = false;
        updateCategories(); updateGrid(); render();
      });
      $('[data-demo-surprise]').addEventListener('click', () => {
        const available = shapes.filter(shape => shape.number !== selected.number && validRow(shape.sizes.find(row => row.overall === Number(width.value))));
        selected = available[Math.floor(Math.random() * available.length)] || selected;
        render();
      });
      useDesign.addEventListener('click', () => {
        if (!validRow(selectedSize())) return;
        const design = {shape:selected.number,width:Number(width.value),height:Number(height.value)};
        try { sessionStorage.setItem('rw-preferred-shape', selected.number); sessionStorage.setItem('rw-preferred-fit', JSON.stringify(design)); } catch {}
        const target = new URL((document.body.dataset.rwRoot || '/') + 'pages/rimless-frames', location.origin);
        target.searchParams.set('shape', design.shape); target.searchParams.set('width', design.width); target.searchParams.set('height', design.height);
        location.href = target.href;
      });
      width.disabled = false; height.disabled = false;
      updateCategories(); updateGrid(); render();
    } catch {
      canvas.innerHTML = `<p>${escape(words.unavailable)}</p>`;
      studio.querySelector('.rw-studio-adjustments').hidden = true;
      studio.querySelector('.rw-studio-shape-browser').hidden = true;
    }
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

